/** Whether a nav link to `href` is the current page or an ancestor of it. */
export function isActivePath(pathname: string, href: string) {
  return pathname === href || pathname.startsWith(`${href}/`)
}
